import React, { useState } from "react";

export default function ExcelTableToSlides() {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  // ✅ Handle CSV Upload (no library needed)
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const text = evt.target.result;
      const lines = text
        .split("\n")
        .map((line) => line.split(",").map((cell) => cell.trim()));

      const [headerRow, ...rowsData] = lines;
      setHeaders(headerRow);
      setRows(rowsData);
      setCurrentPage(0);
    };

    reader.readAsText(file);
  };

  // ✅ Simple "Download as PDF" via browser print dialog
  const downloadPDF = () => {
    const content = document.getElementById("print-section").innerHTML;
    const newWin = window.open("", "_blank");
    newWin.document.write(`
      <html>
        <head>
          <title>Excel Data</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            h2 { margin-bottom: 10px; }
            ul { margin-left: 20px; }
            li { margin: 4px 0; }
          </style>
        </head>
        <body>
          <h2>Excel Data (All Pages)</h2>
          ${rows
            .map(
              (row, pageIndex) => `
            <h3>Page ${pageIndex + 1}</h3>
            <ul>
              ${headers
                .map(
                  (header, idx) =>
                    `<li><strong>${header}:</strong> ${row[idx] || "-"}</li>`
                )
                .join("")}
            </ul>
          `
            )
            .join("")}
        </body>
      </html>
    `);
    newWin.document.close();
    newWin.print();
  };

  const totalPages = rows.length;
  const row = rows[currentPage] || [];

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Upload CSV File</h2>
      <input type="file" accept=".csv" onChange={handleFileUpload} />

      {rows.length > 0 && (
        <div id="print-section" className="mt-6">
          {/* Page Data */}
          <h3 className="text-lg font-semibold mb-2 text-white">
            Page {currentPage + 1} of {totalPages}
          </h3>

          <ul className="list-disc ml-6 mb-6 text-white">
            {headers.map((header, idx) => (
              <li key={idx}>
                <strong>{header}:</strong> {row[idx] ?? "-"}
              </li>
            ))}
          </ul>

          {/* Navigation */}
          <div className="flex gap-2 mb-4">
            <button
              className="px-3 py-1 bg-gray-500 rounded disabled:opacity-50"
              onClick={() => setCurrentPage(0)}
              disabled={currentPage === 0}
            >
              First
            </button>
            <button
              className="px-3 py-1 bg-gray-500 rounded disabled:opacity-50"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 0))}
              disabled={currentPage === 0}
            >
              Previous
            </button>
            <button
              className="px-3 py-1 bg-gray-500 rounded disabled:opacity-50"
              onClick={() =>
                setCurrentPage((p) => Math.min(p + 1, totalPages - 1))
              }
              disabled={currentPage === totalPages - 1}
            >
              Next
            </button>
            <button
              className="px-3 py-1 bg-gray-500 rounded disabled:opacity-50"
              onClick={() => setCurrentPage(totalPages - 1)}
              disabled={currentPage === totalPages - 1}
            >
              Last
            </button>
          </div>

          {/* Download PDF */}
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded"
            onClick={downloadPDF}
          >
            Download as PDF
          </button>
        </div>
      )}
    </div>
  );
}
